import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck, Lock, Eye, Trash2, Database, Camera } from 'lucide-react';

function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-cyan-50 to-teal-100 p-4 sm:p-8">
      <div className="mx-auto max-w-4xl overflow-hidden rounded-3xl border border-emerald-200 bg-white shadow-xl">
        <div className="border-b border-emerald-100 bg-emerald-50 px-6 py-6 sm:px-8">
          <div className="flex items-center gap-3">
            <ShieldCheck className="h-7 w-7 text-emerald-700" />
            <h1 className="text-2xl font-bold text-emerald-900 sm:text-3xl">Politique de confidentialite</h1>
          </div>
          <p className="mt-3 text-sm text-emerald-800 sm:text-base">
            Derniere mise a jour: 14 avril 2026
          </p>
        </div>

        <div className="space-y-8 px-6 py-8 sm:px-8">
          <section>
            <p className="rounded-xl border border-emerald-200 bg-emerald-50 p-4 text-sm font-medium text-emerald-900 sm:text-base">
              Nous ne collectons que les donnees strictement necessaires au fonctionnement de l'application.
            </p>
          </section>

          <section>
            <div className="mb-3 flex items-center gap-2">
              <Database className="h-5 w-5 text-slate-700" />
              <h2 className="text-xl font-semibold text-slate-900">1. Donnees collectees</h2>
            </div>
            <ul className="space-y-2 text-sm text-slate-700 sm:text-base">
              <li>Email utilisateur (identifiant de connexion)</li>
              <li>Nom d'usage (pseudo modifiable)</li>
              <li>Taille du foyer (donnee statistique)</li>
              <li>Donnees d'achat (articles, magasins, montants)</li>
            </ul>
            <p className="mt-3 text-sm text-slate-700 sm:text-base">
              Nous ne stockons pas votre nom reel, votre adresse physique ni d'autres donnees personnelles sensibles.
            </p>
          </section>

          <section>
            <div className="mb-3 flex items-center gap-2">
              <Eye className="h-5 w-5 text-slate-700" />
              <h2 className="text-xl font-semibold text-slate-900">2. Finalites</h2>
            </div>
            <ul className="space-y-2 text-sm text-slate-700 sm:text-base">
              <li>Ameliorer les suggestions de courses</li>
              <li>Suivre le budget et les depenses</li>
              <li>Personnaliser l'experience utilisateur</li>
            </ul>
          </section>

          <section>
            <div className="mb-3 flex items-center gap-2">
              <Lock className="h-5 w-5 text-slate-700" />
              <h2 className="text-xl font-semibold text-slate-900">3. Securite et minimisation</h2>
            </div>
            <ul className="space-y-2 text-sm text-slate-700 sm:text-base">
              <li>Mot de passe chiffre (hachage bcrypt)</li>
              <li>Donnees d'achat rattachees a un identifiant interne unique (UUID)</li>
              <li>Separation entre donnees de compte et donnees de comportement</li>
              <li>Transport des donnees via HTTPS en production</li>
              <li>Acces aux donnees restreint au serveur authentifie</li>
            </ul>
          </section>

          <section>
            <div className="mb-3 flex items-center gap-2">
              <Trash2 className="h-5 w-5 text-slate-700" />
              <h2 className="text-xl font-semibold text-slate-900">4. Vos droits (RGPD)</h2>
            </div>
            <ul className="space-y-2 text-sm text-slate-700 sm:text-base">
              <li>Modifier vos informations de profil</li>
              <li>Supprimer vos donnees de fonctionnement depuis les parametres</li>
              <li>Supprimer votre compte et toutes les donnees associees (action irreversible)</li>
            </ul>
          </section>

          <section>
            <div className="mb-3 flex items-center gap-2">
              <Camera className="h-5 w-5 text-slate-700" />
              <h2 className="text-xl font-semibold text-slate-900">5. Permissions Google Play</h2>
            </div>
            <ul className="space-y-2 text-sm text-slate-700 sm:text-base">
              <li>Camera: uniquement pour scanner les tickets et codes-barres a l'initiative de l'utilisateur</li>
              <li>Stockage/photos: uniquement pour selectionner des images de tickets</li>
              <li>La camera n'est pas utilisee en arriere-plan et n'est activee que pendant l'ecran de scan</li>
              <li>Vous pouvez refuser ou retirer cette permission a tout moment dans les parametres Android</li>
            </ul>
            <p className="mt-3 text-sm text-slate-700 sm:text-base">
              Une explication est affichee dans l'application avant toute demande de permission.
            </p>
          </section>

          <section>
            <div className="mb-3 flex items-center gap-2">
              <ShieldCheck className="h-5 w-5 text-slate-700" />
              <h2 className="text-xl font-semibold text-slate-900">6. Engagement contenus familiaux</h2>
            </div>
            <p className="text-sm text-slate-700 sm:text-base">
              SmartInventory s'engage a respecter les regles Google Play pour les contenus familiaux lorsque l'application
              est distribuee a une audience incluant des enfants.
            </p>
            <ul className="mt-3 space-y-2 text-sm text-slate-700 sm:text-base">
              <li>Les references explicites a l'alcool et aux contenus reserves aux adultes sont retirees des suggestions visibles.</li>
              <li>Les contenus publicitaires affiches dans l'application sont filtres pour exclure alcool, jeux d'argent, rencontres, sexualisation explicite et violence.</li>
              <li>Les permissions et contenus affiches restent limites aux usages utiles a la gestion du foyer et des courses.</li>
            </ul>
          </section>

          <section>
            <div className="mb-3 flex items-center gap-2">
              <ShieldCheck className="h-5 w-5 text-slate-700" />
              <h2 className="text-xl font-semibold text-slate-900">7. Contact</h2>
            </div>
            <p className="text-sm text-slate-700 sm:text-base">
              Pour toute question sur la confidentialite ou l'utilisation des permissions, contactez-nous a:
              {' '}
              <a className="font-medium text-emerald-700 underline" href="mailto:privacy@smartinventory.fr">
                privacy@smartinventory.fr
              </a>
            </p>
          </section>

          <div className="pt-2">
            <Link
              to="/login"
              className="inline-flex items-center rounded-xl bg-emerald-600 px-4 py-2 text-sm font-medium text-white hover:bg-emerald-700"
            >
              Retour a l'application
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
